
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import { View } from "@/models/view";
import { ViewService } from "@/services/view-service";
import AppViewList from "@/components/view-editor/ViewList.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { UserInfo } from "@/models/dossier/user-info";
import { IBreadCrumb } from "winfakt-vue-components";
import { CompanyService } from "../../../services/company-service";
import { Browse } from "../../../models/browse";
import { BrowseService } from "../../../services/browse-service";

export default Vue.extend({
	data(){
		return {
			views: [] as View[],
			userId: 0,
			browseId: 0,
			browse: null as null | Browse,
			user: null as null | UserInfo
		};
	},
	computed: {
		title():string{
			if (!this.browse){
				return "";
			}
			return this.browse.Name.getTranslation(this.$i18n.locale);
		},
		path():IBreadCrumb[]{
			let username = "user";
			if (this.user){
				username = this.user.getShortDisplayName();
			}
			return [
				{
					to: "/settings/",
					value: this.$ct("general").toString()
				},
				{
					to: "/settings/users",
					value: this.$ct("users").toString()
				},
				{
					value: this.$ct("views-of-user", {username}).toString(),
					to: `/settings/users/views/${this.userId}`
				},
				{
					value: this.$ct("views").toString()
				}
			];

		}
	},
	methods: {
		createNewView(){
			this.$router.push(`/settings/users/views/${this.userId}/${this.browseId}/new`);
		},
		editClicked(view:View){
			this.$router.push(`/settings/users/views/${this.userId}/${this.browseId}/${view.ID}`);
		},
		async deleteView(view:View){
			await ViewService.deleteView(view);
			this.views.splice(this.views.indexOf(view), 1);
		}
	},
	async created(){
		this.userId = parseInt(this.$route.params.userId);
		this.browseId = parseInt(this.$route.params.browseId);
		let allViews = await ViewService.getUsersViews(this.userId);
		this.views = allViews.filter(v=>v.BrowseID == this.browseId);
		this.user = await CompanyService.getUser(this.userId);
		this.browse = (await BrowseService.getBrowse(this.browseId)).browse;
	},
	components: {
		AppMobileFullScreenContainer,
		AppViewList,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
